import {
    axios
} from '@/utils/request';

/**
 * index func
 * @param parameter
 * @returns {*}
 */
//查询视频课程分类
export function apiGetVideoCourseKind(parameter) {
    return axios({
        url: '/course/getVideoCourseKind',
        method: 'post',
        data: parameter
    })
}
//查询直播课程分类
export function apiGetLiveCourseKind(parameter) {
    return axios({
        url: '/course/getLiveCourseKind',
        method: 'post',
        data: parameter
    })
}
//查询课程列表
export function apiGetCourseList(parameter) {
    return axios({
        url: '/course/getCourseList',
        method: 'post',
        data: parameter
    })
}
//查询视频课程详情
export function apiGetVideoCourseDes(parameter) {
    return axios({
        url: '/course/getVideoCourseDesc',
        method: 'post',
        data: parameter
    })
}
//查询视频课程章节
export function apiGetVideoCourseChapter(parameter) {
    return axios({
        url: '/course/getCourseChapter',
        method: 'post',
        data: parameter
    })
}
//查询直播课程章节
export function apiGetLiveCourseChapter(parameter) {
    return axios({
        url: '/liveCourse/queryLiveChapter',
        method: 'post',
        data: parameter
    })
}
//查询直播课程详情
export function apiGetLiveCourseDes(parameter) {
    return axios({
        url: '/liveCourse/getLiveCourseDesc',
        method: 'post',
        data: parameter
    })
}
//查询课程评论列表
export function apiGetCourseQuesAns(parameter) {
    return axios({
        url: '/course/comment/getCourseQuesAns',
        method: 'post',
        data: parameter
    })
}
//视频课程鉴权
export function apiCheckVideoAuth(parameter) {
    return axios({
        url: '/course/checkVideoAuth',
        method: 'post',
        data: parameter
    })
}
//直播地址鉴权
export function apiCheckLiveUrlToken(parameter) {
    return axios({
        url: '/liveCourse/checkLiveUrlToken',
        method: 'post',
        data: parameter
    })
}
//直播回访鉴权
export function apiCheckPlaybackUrlToken(parameter) {
    return axios({
        url: '/liveCourse/checkPlaybackUrlToken',
        method: 'post',
        data: parameter
    })
}
//发表评论
export function apiInsertReply(parameter) {
    return axios({
        url: '/course/comment/insertReply',
        method: 'post',
        data: parameter
    })
}
//收藏/取消收藏课程
export function apiCollectCheck(parameter) {
    return axios({
        url: '/course/collect/changeCourseCollectStatus',
        method: 'post',
        data: parameter
    })
}
//购买课程
export function apiToBuyCourse(parameter) {
    return axios({
        url: '/pay/buyCourseForApp',
        method: 'post',
        data: parameter
    })
}
//检查课程订单支付状态
export function apiCheckCourseOrder(parameter) {
    return axios({
        url: '/pay/checkCoursePayStatus',
        method: 'post',
        data: parameter
    })
}